// Import styles
require('normalize.css/normalize.css')
require('./styles/index.scss')

import image from './assets/colour-image.png'

// import sponsorLogo from './assets/ryman-logo.jpg'
import projectLogo from './assets/project-title.png'

// Import classes
import Scene from './classes/Scene'

// Init app
document.addEventListener('DOMContentLoaded', () => {
  const scene = new Scene({
    canvasContainer: 'pascalls_kiwi',
    sidebar: 'sidebar',
    canvas: {
      interface: 'canvas_interface',
      drawing: 'canvas_drawing',
      temp: 'canvas_temp'
    },
    slider: {
      brush: 'slider_brush',
      lazy: 'slider_lazy'
    },
    picker: {
      brush: 'picker_brush',
    },
    button: {
      mode: 'button_mode'
    },
    image: {
      id: 'canvas_grid',
      src: image
    }
  }) 

  scene.init()

  // var sponsor_logo = document.getElementById("sponsor-logo")
  // sponsor_logo.src = sponsorLogo

  var project_logo = document.getElementById("project-logo")
  project_logo.src = projectLogo

  var header = document.querySelector('.stuff_simpleheader'),
      stuffheader_body = document.createElement('div'),
      stuffheader_left = document.createElement('div'),
      stuffLink = document.createElement('a'),
      stuffheader_right = document.createElement('div'),
      stuffSocial = document.createElement('div'),
      stuffheader_color_bar = document.createElement('div'),
      fbLink = document.createElement('a'),
      twitterLink = document.createElement('a'),
      shareURL = encodeURIComponent(document.querySelector("[property='og:url']").content),
      fbDescription = encodeURIComponent(document.querySelector("[property='og:description']").content),
      twitterDescription = encodeURIComponent(document.querySelector("[name='twitter:description']").content),
      breakWidth = 840,
      prevScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  stuffheader_body.classList.add('stuffheader_body');
  stuffheader_left.classList.add('stuffheader_left');
  stuffLink.classList.add('stufflogo');
  stuffLink.href = "https://stuff.co.nz";
  stuffheader_right.classList.add('stuffheader_right');
  stuffheader_left.appendChild(stuffLink);
  stuffSocial.classList.add('shareBlock');
  fbLink.classList.add('shareBtn');
  fbLink.classList.add('share_facebook');
  twitterLink.classList.add('shareBtn');
  twitterLink.classList.add('share_twitter');
  stuffSocial.appendChild(fbLink);
  stuffSocial.appendChild(twitterLink);
  stuffheader_right.appendChild(stuffSocial);
  stuffheader_body.appendChild(stuffheader_left);
  stuffheader_body.appendChild(stuffheader_right);
  stuffheader_color_bar.classList.add('stuff_color_bar');
  header.appendChild(stuffheader_body);

 //calculates viewport size
  function getWindowDim() {
    var width = Math.min(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth),
        height = Math.min(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight, window.innerHeight);
    return {
      width: width,
      height: height
    };
  }

  function difference(a, b) {
    return Math.abs(Math.abs(a) - Math.abs(b));
  }

  fbLink.addEventListener('click', function (e) {
    e.preventDefault();
    var windowWidth = getWindowDim().width,
        left = (windowWidth - 600) / 2,
        fbURL = "https://www.facebook.com/sharer/sharer.php?u=" + shareURL;

    if (windowWidth > breakWidth) {
      window.open(fbURL, 'facebook', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(fbURL);
    }
  });
  twitterLink.addEventListener('click', function (e) {
    e.preventDefault();
    var windowWidth = getWindowDim().width,
        left = (windowWidth - 600) / 2,
        twitURL = "https://twitter.com/intent/tweet?url=" + shareURL + "&text=" + twitterDescription + "&via=NZSTUFF";

    if (windowWidth > breakWidth) {
      window.open(twitURL, 'twitter', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(twitURL);
    }
  }); // move first element after header to below the fixed header height
})
